import { siteName } from '@app/utils/constants';

export type PageMetaProps = {
	title?: string;
	seperator?: string;
};

export const PageMeta = ({ title = '', seperator = '-' }: PageMetaProps) => {
	const metaTitle = title ? `${title} ${seperator} ${siteName}` : siteName;
	return <>{metaTitle ? <title>{metaTitle}</title> : null}</>;
};
